import * as React from "react";
/**
 * Shield Lock icon rendered with the brand purple → light blue gradient
 * used in the Plan details dialog navigation. Path data mirrors
 * `ShieldLockRegular` from `@fluentui/react-icons`; gradient stops are
 * sourced from the Figma redline*/ export const ShieldLockGradient20 = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.34c-.26-.38-.6-.7-1-.94V5.43a15.97 15.97 0 0 1-5.6-2.08L10 3.1l-.4.25A15.97 15.97 0 0 1 4 5.43V9.5c0 3.4 1.97 5.86 6 7.46V17a2 2 0 0 0 .24.94l-.06.03a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM12.5 12v-1a2 2 0 1 1 4 0v1h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h.5Zm1-1v1h2v-1a1 1 0 1 0-2 0Zm1.75 4a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z",
        fill: "url(#paint0_shield_gradient_20)"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_shield_gradient_20",
        x1: "3",
        y1: "2",
        x2: "13.5",
        y2: "18",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#7E6DFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#A0B7FF"
    }))));
